import {
  cartInit,
} from './components/index';

const RcCart = {
  init() {
    cartInit();
  }
};

export default RcCart;

RcCart.init();
